const Loading = () => {
    return <>Loading, please wait...</>;
};

export default Loading;
